import { useState } from 'react';
import CustomModal from '../../../../../core/components/core/Util/Modal/CustomModal';
import Fetch from '../../../../../core/util/core/Fetch';
import Toast from '../../../../../core/components/core/Util/Toast/Toast';
import { generatePositionsPdf } from './generatePositionsPdf';

export function usePositionsExport({ endpoint, baseFilter }) {
    const [showModal, setShowModal] = useState(false);
    const [sortOrder, setSortOrder] = useState('alphabetical');
    const [statusFilter, setStatusFilter] = useState('active');
    const [isGenerating, setIsGenerating] = useState(false);

    const openModal = () => setShowModal(true);
    const closeModal = () => setShowModal(false);

    const handleGenerate = async () => {
        setIsGenerating(true);
        try {
            const order = sortOrder === 'cbo' ? [['co.code', 'ASC']] : [['rn.name', 'ASC']];
            const filter = { ...baseFilter };
            if (statusFilter === 'active') {
                filter.status = '1';
            }

            const rows = await Fetch.post(endpoint, { filter, order });

            if (!rows || rows.length === 0) {
                Toast.error('Nenhum cargo encontrado para os filtros selecionados.');
                setIsGenerating(false);
                return;
            }

            generatePositionsPdf(rows);
            closeModal();
        } catch (e) {
            Toast.error(e);
        }
        setIsGenerating(false);
    };

    const modalContent = (
        <div>
            <div style={{ marginBottom: '20px' }}>
                <label><strong>Ordenação</strong></label>
                <div>
                    <label style={{ marginRight: '15px', fontWeight: 'normal' }}>
                        <input
                            type="radio"
                            name="pdc-positions-export-sort"
                            checked={sortOrder === 'alphabetical'}
                            onChange={() => setSortOrder('alphabetical')}
                        /> Ordem Alfabética (Nome do Cargo de A a Z)
                    </label>
                </div>
                <div>
                    <label style={{ fontWeight: 'normal' }}>
                        <input
                            type="radio"
                            name="pdc-positions-export-sort"
                            checked={sortOrder === 'cbo'}
                            onChange={() => setSortOrder('cbo')}
                        /> Ordem por Código CBO (Numérico crescente)
                    </label>
                </div>
            </div>
            <div>
                <label><strong>Status</strong></label>
                <div>
                    <label style={{ marginRight: '15px', fontWeight: 'normal' }}>
                        <input
                            type="radio"
                            name="pdc-positions-export-status"
                            checked={statusFilter === 'active'}
                            onChange={() => setStatusFilter('active')}
                        /> Apenas Ativos
                    </label>
                </div>
                <div>
                    <label style={{ fontWeight: 'normal' }}>
                        <input
                            type="radio"
                            name="pdc-positions-export-status"
                            checked={statusFilter === 'all'}
                            onChange={() => setStatusFilter('all')}
                        /> Todos (Ativos e Inativos)
                    </label>
                </div>
            </div>
        </div>
    );

    const modal = (
        <CustomModal
            show={showModal}
            title="Gerar Fichas de Cargos (PDF)"
            content={modalContent}
            handleClose={closeModal}
            handleCancel={closeModal}
            handleConfirm={handleGenerate}
            confirmButtonText={isGenerating ? 'Gerando...' : 'Gerar PDF'}
            cancelButtonText="Cancelar"
        />
    );

    return { modal, openModal };
}
